import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FeedbackService } from '@app/core/services';
import { TableConfig, TableFilter } from '@app/interfaces';
import { EmployeeModel } from '@app/modules/fund-management/reports/models/employee.model';
import { EmployeeService } from '@app/shared/services/employee.service';
import { FiltersComponent } from '../../forms/components/filters/filters.component';
import { ModalComponent } from '../modal/modal.component';
import { TableComponent } from '../table/table.component';

@Component({
    selector: 'employee-search',
    templateUrl: './employee-search.component.html',
    standalone: true,
    imports: [
        ModalComponent,
        FiltersComponent,
        TableComponent,
    ],
})
export class EmployeeSearchComponent implements OnInit {
	config: TableConfig<EmployeeModel> = {
		columns: [
			{
				header: 'Employee #',
				key: 'EmployeeNumber',
			},
			{
				header: 'Name',
				key: 'FormattedFormalName',
			},
			{
				header: 'Primary Site',
				key: 'SiteCode',
			},
			{
				header: 'Status',
				key: 'Status',
			},
		],
		defaultSortDirection: 'asc',
		defaultSortField: 'FormattedFormalName',
		onRowClick: (row: EmployeeModel) => {
			this.dialogRef.close(row);
		},
	};
	data: EmployeeModel[] = [];
	filters = { search: '' };

	constructor(
		private readonly employeeService: EmployeeService,
		private readonly feedbackService: FeedbackService,
		public dialogRef: MatDialogRef<EmployeeSearchComponent>
	) {}

	ngOnInit(): void {
		this.employeeService.getEmployeeList().subscribe({
			next: (response) => {
				this.data = response.employees;
			},
			error: (error: HttpErrorResponse) => {
				const errorMessage = error.error?.ExceptionMessage || error.error?.Message || '';
				this.feedbackService.error(`There was a problem loading Employee List: ${errorMessage}`);
			},
		});
	}

	applyFilter(filterValue: Partial<TableFilter<EmployeeModel>>): void {
		this.filters = { ...this.filters, ...filterValue };
	}
}
